var exports = {
  "k": "x4c3adb35--88d0a8--container",
};

module.exports = exports;
